// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2VOs4","left":"InfoRow_left__2te0p"};